import { createSharedState } from '@ai-indeed/hooks';

// 用于指定区域高亮
export const useSpecificAreaId = createSharedState<string>('');
